import {
  CalendarIcon,
  ClockIcon,
  HourglassIcon,
  InboxIcon,
  MilestoneIcon,
  PeopleIcon,
  WorkflowIcon
} from '@chaine/keychaine'

import { ConditionConjunctionEnum, EntityTypeEnum } from '../types'
import { shipmentFieldOptions } from './shipment-field-options'
import { stopFieldOptions } from './stop-field-options'

//*********************     DEFAULT VALUES*********************/

/**
 * Default field name for a reference shipment field name
 */

export const defaultDateFieldName = (entityType?: EntityTypeEnum) => {
  const fieldNameMap: Record<EntityTypeEnum, string> = {
    [EntityTypeEnum.None]: '',
    [EntityTypeEnum.Shipment]: shipmentFieldOptions['origin.appointment.start'].name,
    [EntityTypeEnum.Stop]: stopFieldOptions['appointment.start'].name
  }
  return fieldNameMap[entityType ?? EntityTypeEnum.None]
}

/**
 * Default field value for a reference shipment field value
 */
export const defaultDateFieldValue = (entityType?: EntityTypeEnum) => {
  const fieldValueMap: Record<EntityTypeEnum, string> = {
    [EntityTypeEnum.None]: '',
    [EntityTypeEnum.Shipment]: shipmentFieldOptions['origin.appointment.start'].value,
    [EntityTypeEnum.Stop]: stopFieldOptions['appointment.start'].value
  }
  return fieldValueMap[entityType ?? EntityTypeEnum.None]
}

/**
 * Default entity type for a trigger or condition
 */
export const defaultEntityType = EntityTypeEnum.Shipment
/**
 * Default number for a trigger or condition
 */
export const defaultNumber = 0
/**
 * Default time for a trigger or condition
 */
export const defaultTime = '00:00'
/**
 * Default timezone for a trigger or condition
 */
export const defaultTimezone = 'America/Chicago'

//*********************     TRIGGER DEFAULTS     *********************/

export const conditionsTriggerDefaults = {
  icon: WorkflowIcon,
  title: 'When all conditions match'
}

export const daysOffsetFieldTriggerDefaults = {
  icon: CalendarIcon,
  title: 'A number of days before/after...'
}

export const exactTimeFieldTriggerDefaults = {
  icon: MilestoneIcon,
  title: 'At the time of...'
}

export const exactTimeTriggerDefaults = {
  icon: ClockIcon,
  title: 'At a specific time...'
}

export const hoursMinutesOffsetFieldTriggerDefaults = {
  icon: HourglassIcon,
  title: 'A number of hours before/after...'
}

export const triggerRuleTitle = 'When'

//*********************     ACTION DEFAULTS     *********************/
export const sendChatMessageActionDefault = {
  icon: InboxIcon,
  title: 'Send a chat message...'
}

export const sendEmailActionDefault = {
  icon: InboxIcon,
  title: 'Send an email...'
}

export const assignUsersToEntityActionDefault = {
  icon: PeopleIcon,
  title: 'Assign Users to Shipment'
}

//*********************     CONDITION DEFAULTS     *********************/
export const defaultConditionConjunction = ConditionConjunctionEnum.AND

export const addNewConditionTooltipText = 'Add another condition'

export const addNewActionTooltipText = 'Add another action'

export const actionsRuleTitle = 'Do this'

export const conditionsRuleTitle = 'Check if'
